import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from "clsx";
import { withStyles, Popover, ButtonGroup, Button, IconButton } from "@material-ui/core";
import SettingsIcon from "../../Utilities/RollingIcon/SettingsIcon";
import { notArrayOrEmpty } from '../../../utils/helpers';
import guid from './../../../utils/guid';

const useStyles = theme => ({
    active: {
        color: theme.palette.primary.main
    }
});

const PeriodSelect = ({classes, value, onChange, className, buttonOptions}) => {
    const [anchorEl, setAnchorEl] = useState();

    const handleClose = () => setAnchorEl(null);

    const printButtons = (buttons) => {
        if(notArrayOrEmpty(buttons))
            return;
        return buttons.map(button => (
            <Button
                key={guid()}
                className={clsx({[classes.active]: value === button.value})}
                onClick={() => onChange && onChange(button.value)}
            >
                {button.name}
            </Button>
        ));
    };

    return (
        <React.Fragment>
            <IconButton
                className={className}
                onClick={(e) => setAnchorEl(e.currentTarget)}
            >
                <SettingsIcon />
            </IconButton>
            <Popover
                anchorOrigin={{
                vertical: 'center',
                horizontal: 'right',
                }}
                transformOrigin={{
                vertical: 'center',
                horizontal: 'left',
                }}
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handleClose}
            >
                <ButtonGroup
                    variant="text"
                >
                    {printButtons(buttonOptions)}
                </ButtonGroup>
            </Popover>
        </React.Fragment>
    );
};

PeriodSelect.propTypes = {
    classes: PropTypes.object,
    className: PropTypes.string,
    value: PropTypes.any,
    onChange: PropTypes.func,
    buttonOptions: PropTypes.array
};

export default withStyles(useStyles)(PeriodSelect);
